import { useAtom } from 'jotai';
import { ReactElement } from 'react';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { ListItemButton, ListItemIcon, ListItemText, Collapse } from '@mui/material';
import { currentExpandedAccordionAtom } from '../state/state';
import SelectFilterChip from '../../common/components/SelectFilterChip';

export type FilterDisplayMode = 'POPOVER' | 'ACCORDION';

interface FilterDisplayProps {
  label: string;
  activeItemCount?: number;
  content: React.JSX.Element;
  mode?: FilterDisplayMode;
  name?: string;
  onClose?: () => void;
  icon?: ReactElement;
  unmountOnExit ?: boolean;
}

export default function FilterDisplay({ icon, label, activeItemCount, content, mode, name, unmountOnExit = true, onClose }: FilterDisplayProps): React.JSX.Element {
  const [currentExpandedAccordion, setCurrentExpandedAccordion] = useAtom(currentExpandedAccordionAtom);

  const handleAccordionChange = (): void => {
    setCurrentExpandedAccordion(currentExpandedAccordion === name ? null : name!);
  };

  if (mode === 'ACCORDION') {
    return (
      <>
        <ListItemButton onClick={handleAccordionChange}>
          <ListItemIcon>
            {icon}
          </ListItemIcon>
          <ListItemText primary={label} />
          <ListItemIcon>
            {currentExpandedAccordion === name ? <ExpandLess /> : <ExpandMore />}
          </ListItemIcon>
        </ListItemButton>
        <Collapse
          in={currentExpandedAccordion === name}
          timeout="auto"
          unmountOnExit={unmountOnExit}
          sx={{
            p: currentExpandedAccordion === name ? 2 : 0,
          }}
        >
          {content}
        </Collapse>
      </>
    );
  }

  return (
    <SelectFilterChip
      isFilterActive={!!activeItemCount}
      label={label}
      content={content}
      icon={icon}
      onClose={onClose}
    />

  );
}
